// shared-data.service.ts
import { Injectable, signal } from '@angular/core';
import { Bot } from './bot.interface';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
@Injectable({
    providedIn: 'root'
})
export class BotService {
    costCode: any;
    userEmail: string;
    constructor(private authService: AuthService) {
        //this.costCode = authService.getUserCostCode();
        this.userEmail = authService.getUserEmail();
        
        console.log("This is the email", this.userEmail)
    }
    private baseBotUrl = environment.coreAIBotURL;
    private baseBotUrl_old = environment.coreAIBotURL_old;

    getBotByFragment(fragmentId: string): string | undefined {
        const allBots = this.getAllBots();
        const bot = allBots.find(bot => bot.fragment.toLowerCase() === fragmentId.toLowerCase());
        return bot ? bot.url : undefined;
    }




    getAllBots(): Bot[] {
        //const botDevURL = 'https://aia-test-angular-ehf8hygsehasfqcg.westeurope-01.azurewebsites.net/';
        return [
            {
                name: 'IT Assistant',
                isPlugin: false,
                description: 'Assists users with IT issues, ensuring smooth system operations.',
                url: environment.production ? `${this.baseBotUrl}It?source=ghub` : `${this.baseBotUrl}IT?source=ghub`,
                image: 'it-bot.svg',
                fragment: 'IT',
                costCode: [],
                hasAccess: [],
                band: [],
                redirectToSite: false,
            },
            {
                name: 'Global Mobility Services',
                isPlugin: false,
                description: 'Provides guidance for employee relocation across international locations.',
                url: environment.production ? `${this.baseBotUrl}GMS?source=ghub` : `${this.baseBotUrl}gms?source=ghub`,
                image: 'gms-bot.svg',
                fragment: 'GMS',
                costCode: [],
                hasAccess: [],
                band: [],
                redirectToSite: false,
            },
            {
                name: 'LDT AI Mentor',
                isPlugin: false,
                description: 'Guides users with Lean Digital Transformations, Six Sigma, and more .',
                url: environment.production ? `${this.baseBotUrl}emma?source=ghub` : `${this.baseBotUrl}emma?source=ghub`,
                image: 'ldt-bot.svg',
                fragment: 'LDT-AI-Mentor',
                costCode: [],
                hasAccess: [],
                band: [],
                redirectToSite: false,
            },
            {
                name: 'Finance Assistant',
                isPlugin: false,
                description: 'Assist and answer queries related to Payroll, T&L (Concur) and Projects (PIDs)',
                url: environment.production ? `${this.baseBotUrl}finance?source=ghub` : `${this.baseBotUrl}finance?source=ghub`,
                image: 'coin.svg',
                fragment: 'Finance-Assistant',
                costCode: [],
                hasAccess: [],
                band: [],
                redirectToSite: false,
            },
            /*{
                name: 'Infosec & Privacy',
                isPlugin: false,
                description: 'Addresses queries about data privacy and information security issues.',
                url: environment.production ? `${this.baseBotUrl}infoseca` : `${this.baseBotUrl}infosec`,
                image: 'infosec-bot.svg',
                fragment: 'Infosec',
                costCode: [],
                hasAccess: [],
                band: [],
                redirectToSite: false,
            },*/
            {
                name: 'HRpedia',
                isPlugin: false,
                description: 'Answers employee questions, automates HR tasks, and offers support.',
                url: environment.production ? `${this.baseBotUrl}askhra?source=ghub` : `${this.baseBotUrl}askhra?source=ghub`,
                image: 'hr-bot.svg',
                fragment: 'HRpedia',
                costCode: [],
                hasAccess: ['Ramakrishna.Anand@genpact.com','aditya.gupta@genpact.com', 'gaurav.sharma24@genpact.com', 'nitin.sharma18@genpact.com', 'dheeraj.tyagi@genpact.com'],
                band: ['1.1', '2.2', '3.3', '4.4A', '4.4B','4.4C' ,'4.4D', '5.5A','5.5B','CEO.CEO', 'SVP.SVP','EVP.EVP'],
                redirectToSite: false,
            },
            /*{
                name: 'Legal Assistant',
                isPlugin: true,
                description: 'Assists with raising requests for Contract and Signature review.',
                url: environment.production ? `${this.baseBotUrl}legal` : `${this.baseBotUrl}legal`,
                image: 'legal.svg',
                fragment: 'Legal-Frontdoor',
                costCode: [],
                hasAccess: [],
                band: ['1.1', '2.2', '3.3', '4.4D','CEO.CEO', 'SVP.SVP','EVP.EVP'],
                redirectToSite: false,
            },*/
            {
                name: 'Facilities',
                isPlugin: false,
                description: 'Get assistance with infrastructure and logistical support inquiries. ',
                url: environment.production ? `${this.baseBotUrl}InL?source=ghub` : `${this.baseBotUrl}InL?source=ghub`,
                image: 'facilities-bot.svg',
                fragment: 'Facilities',
                costCode: [],
                hasAccess: [],
                band: [],
                redirectToSite: false,
            },
            // {
            //     name: 'AI Guru',
            //     isPlugin: true,
            //     description: 'Your Genome learning assistant. Get expert insights and nano-learning on skills, client offerings and BUILD.',
            //     url: environment.production ? 'https://genome-uat.genpact.com/v6#aiguru' : 'https://genome-dev.genpact.com/#aiguru',
            //     image: 'ai-guru-bot.svg',
            //     fragment: 'AI-Guru',
            //     costCode: [],
            //     hasAccess: [],
            //     band: [],
            //     redirectToSite: false,
            // },
            // Add more bots as needed
        ];
    }

    // Filter bots based on user cost code
    async getBotsByCostCode(): Promise<Bot[]> {
        try {
            // Ensure costCode is available
            if (this.costCode === undefined) {
                this.costCode = await this.authService.getUserCostCode();
            }

            const bandCode = await this.authService.getBandInfo();
            // Get all bots
            const allBots = await this.getAllBots();

            const compareBands = (configuredBand: string, userBand: string): boolean => {
                // console.log("Comparing", configuredBand.includes(userBand), configuredBand, userBand)
                if(userBand) {
                    return configuredBand.includes(userBand);
                } 
                return false;
            };

            const compareEmails = (email1:string, email2:string) => email1 && email2 ? email1.toLowerCase() === email2.toLowerCase() : false;
    

            // Filter bots based on costCode and access
            return allBots.filter(bot => {
                // If accessMatch is true, immediately grant access
                const accessMatch = bot.hasAccess.length > 0 && bot.hasAccess.some(email => compareEmails(email, this.userEmail));
            
                // If accessMatch is false, evaluate bandMatch
                const bandMatch = !bot.band?.length || bot.band.some(band => compareBands(band.toString(), bandCode));
            
                // Grant access if either accessMatch or bandMatch is true
                return accessMatch || bandMatch;
            });
            
            
        } catch (error) {
            console.error("Error in getBotsByCostCode:", error);
            return [];
        }
    }




    // Filter bots based on URL
    getBotByUrl(url: string): Bot[] {

        if( environment.deployment == 'UAT' || environment.deployment == 'PROD') url = url+'?source=ghub'
        
        return this.getAllBots().filter(bot => {
            //console.log("Match with", bot.url, url);
            return (bot.url === url);
        });

    }

}